export class ICompanyContactPackageBuider {
    _id             : string;
    companyName     : string;
    name            : string;
    email           : string;
    contactNo       : number;
    officeContactNo : number;
    officeAddress   : string;
    companyCard     : string;
}